module.exports = __webpack_public_path__ + "img/index-section7-award202502.0d4531fe.png";